
import React from 'react';

import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles(( /* theme */) => ({
    root: {
        width: 250,
    },
    input: {
        width: 42,
    },
}));

const RatingInput = ({value, setValue, min, max, inputName}) => {
    const classes = useStyles();

    const handleSliderChanged = (event, newValue) => {
        setValue(newValue);
    }

    const handleInputChanged = (event) => {
        setValue(event.target.value === '' ? '' : Number(event.target.value));
    }

    const handleBlur = () => {
        if (value < min) {
            setValue(0);
        } else if (value > max) {
            setValue(max);
        }
    };


    return (
        <div className={classes.root}>
            <Typography id="input-slider" gutterBottom>
                {inputName}
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={1} />
                <Grid item xs>
                    <Slider
                        value={typeof value === 'number' ? value : 0}
                        onChange={handleSliderChanged}
                        aria-labelledby="input-slider"
                        step={1}
                        marks={[{value: 0, label: "0"},{value: max, label: max}]}
                        min={0}
                        max={max}
                    />
                </Grid>
                <Grid item xs={1} />
                <Grid item>
                    <Input
                        className={classes.input}
                        value={value}
                        margin="dense"
                        onChange={handleInputChanged}
                        onBlur={handleBlur}
                        inputProps={{
                            step: 1,
                            min: 0,
                            max: max,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

RatingInput.propTypes = {
    value: PropTypes.number.isRequired, 
    setValue: PropTypes.func.isRequired, 
    min: PropTypes.number.isRequired, 
    max: PropTypes.number.isRequired, 
    inputName: PropTypes.string.isRequired
}

export default RatingInput
